import React from 'react';
import { Block, DefaultText } from '@guryou/html-components';

const CustomButton = ({ handleClick, label, isActive, value }) => {
  return (
    <button
      key={value}
      type="button"
      onClick={() => handleClick(value)}
      style={{
        padding: '8px 18px',
        borderRadius: '999px',
        border: '2px solid',
        borderColor: isActive ? '#e6616a' : '#444',
        backgroundColor: isActive ? '#e6616a' : '#1f1f1f',
        color: isActive ? '#fff' : '#ccc',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      {label}
    </button>
  );
};

const ButtonGroup = ({ title, options, value, onChange, isMultiSelect = false, maxSelect = 3, isMultiAreaEnabled = true }) => {
  const handleClick = optionValue => {
    if (isMultiSelect) {
      const isSelected = value.includes(optionValue);
      if (isMultiAreaEnabled && optionValue === 'Multi-area') {
        if (isSelected) {
          onChange([]);
        } else {
          onChange(['Multi-area']);
        }
      } else {
        const filtered = isMultiAreaEnabled ? value.filter(v => v !== 'Multi-area') : value;

        if (isSelected) {
          onChange(filtered.filter(v => v !== optionValue));
        } else {
          if (filtered.length >= maxSelect) {
            return;
          }
          onChange([...filtered, optionValue]);
        }
      }
    } else {
      onChange(optionValue);
    }
  };

  const isActive = optionValue => {
    return isMultiSelect ? value.includes(optionValue) : value === optionValue;
  };

  return (
    <Block marginBottom="0.6rem" width="auto">
      <DefaultText marginBottom="0.1rem" fontSize="1.1rem" fontWeight="800" color="#ccc">
        {title}
      </DefaultText>
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        {options.map(option => {
          const isActiveVal = isActive(option.value);
          return <CustomButton value={option.value} label={option.label} isActive={isActiveVal} handleClick={handleClick} />;
        })}
      </div>
    </Block>
  );
};

export default ButtonGroup;
